import React, { useContext, useEffect, useState } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import '@videojs/themes/dist/fantasy/index.css'
import 'videojs-contrib-ads/dist/videojs-contrib-ads.css'
import qualityLevels from 'videojs-contrib-quality-levels'
import hlsQualitySelector from 'videojs-hls-quality-selector'
import './videoJsStyle.css'
import './customVideoJs.css'
import ads from 'videojs-contrib-ads'
import { AdSecondsConvert, captureGAEvent, getImage } from '../../utils/helper'
import { AppContext } from '../../context/app'
import SkipIcon from '../../assets/skip-ad-arrow.svg'
import { isEmpty } from 'lodash'
import { useInterval } from '../../hooks/useInterval'
import NextIcon from '../../assets/player/next-icon.svg'
import PlayIcon from '../../assets/player/yt-play-icon.svg'
import PauseIcon from '../../assets/player/yt-pause-icon.svg'
import SettingsIcon from '../../assets/player/setting-icon.svg'
import FullscreenEnterIcon from '../../assets/player/fullscreen-enter-icon.svg'
import FullscreenExitIcon from '../../assets/player/fullscreen-exit-icon.svg'
import PIPIcon from '../../assets/player/picture-inpicture-icon.svg'
import CaptureIcon from '../../assets/player/capture-icon.svg'
import VolFullIcon from '../../assets/player/volume-full-icon.svg'
import VolLowIcon from '../../assets/player/volume-low-icon.svg'
import VolZeroIcon from '../../assets/player/volume-zero-icon.svg'
import VolMuteIcon from '../../assets/player/volume-mute-icon.svg'
import CentredPlayIcon from '../../assets/light-play-icon.svg'
import RedCircle from '../../assets/red_circle.gif'
import { convertVideoSecondstoMintues } from './playerHelper'
import SettingsMenu from './settingsMenu'
import { isMobile } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import HeaderBar from './headerBar/headerBar'
import PlayerLogo from './screenComponents/playerLogo'
import PlayerWatermark from './screenComponents/playerWatermark'
import TipButtonsBar from './tipButtonsBar'
import useAdvertisementHook from './advertisementHook'
import CustomImage from '../customImage/customImage'
import NonLinearCloseIcon from '../../assets/non-linear-ad-close.svg'
import useAxios from 'axios-hooks'
import { LIVE_ADHOC_AD_API } from '../../utils/apiUrls'
import { useParams } from 'react-router'
import AdhocAdPlayer from './adhocAdPlayer'

const CustomVideoJs = (props) => {
  const { t } = useTranslation()
  const contentId = useParams().contentId
  const {
    contentInfo,
    options,
    onReady,
    controlBar,
    adSetData,
    isLive,
    isVODLive,
    handleNext = null,
    handlePrev = null,
    stillWatchingAllowed = false,
    playerData,
    isAudio = false,
  } = props

  const {
    accountObj,
    setOpenAreYouStillWatching,
    lastMouseMovedSec,
    userObj,
    setLastMouseMovedSec,
  } = useContext(AppContext)

  const {
    playPreRoll,
    playMidRoll,
    playPostRoll,
    playCustomRoll,
    currentPlayingAd,
    getStyleValue,
    handleRedirect,
    positionConfig,
    handleSkip,
    adDuration,
    skipSeconds,
    handleAdEventCall,
  } = useAdvertisementHook()

  const stillWatchingActivated = accountObj?.od_resource_allowances?.activate_still_watching
  const stillWatchingTime = accountObj?.od_resource_allowances?.still_watching_time
  const isAdhocAdBreakAllowed = accountObj?.od_resource_allowances?.is_adhoc_ad_break_enabled

  const videoRef = React.useRef(null)
  const playerRef = React.useRef(null)

  const [duration, setDuration] = useState(null)
  const [currentTime, setCurrentTime] = useState(null)
  const [bufferPercent, setBufferPercent] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [volume, setVolume] = useState(100)
  const [isMute, setIsMute] = useState(false)
  const [isFullScreen, setIsFullScreen] = useState(false)
  const [isPIPMode, setIsPIPMode] = useState(false)
  const [seekBarHoverPercent, setSeekBarHoverPercent] = useState(0)
  const [showVolume, setShowVolume] = useState(false)
  const [showSettingMenu, setShowSettingMenu] = useState(false)
  const [tipJarButtons, setTipJarButtons] = useState({})
  const [showControlBar, setShowControlBar] = useState(false)
  const [cursorOverControlBar, setCursorOverControlBar] = useState(false)
  const [playerStarted, setPlayerStarted] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const [volumeLevel, setVolumeLevel] = useState(1)

  const [nonLinearAds, setNonLinearAds] = useState([])
  const [currentPlayingAdhocAd, setCurrentPlayingAdhocAd] = useState({})

  const [{ data: liveAdhocAdData, error: liveAdhocAdError }, liveAdhocAdCall] = useAxios(
    {
      url: `${LIVE_ADHOC_AD_API}/${contentId}`,
      method: 'get',
    },
    { manual: true, autoCancel: false },
  )

  useEffect(() => {
    if (!isEmpty(adSetData)) {
      setNonLinearAds(adSetData.filter((info) => info.ad_type === 'non_linear'))
    }
  }, [adSetData])

  useEffect(() => {
    if (liveAdhocAdData && liveAdhocAdData?.success) {
      const liveAdhocAdObj = liveAdhocAdData?.data
      if (!isEmpty(liveAdhocAdObj)) {
        if (liveAdhocAdObj?.ad_set_data.mode === 'STOP' && !isEmpty(currentPlayingAdhocAd)) {
          setCurrentPlayingAdhocAd({})
          if (playerRef.current) {
            playerRef.current.muted(false)
          }
          return
        }
        if (currentPlayingAdhocAd?._id !== liveAdhocAdObj?.ad_set_data?._id) {
          if (playerRef.current && playerStarted) {
            const currentMutedState = playerRef.current.muted()
            const currentVolume = playerRef.current.volume()
            playerRef.current.muted(true)
            setVolumeLevel(currentVolume)
            setIsMuted(liveAdhocAdObj?.ad_set_data.mode === 'SWITCH' ? false : currentMutedState)
            setCurrentPlayingAdhocAd(liveAdhocAdObj?.ad_set_data)
          }
        }
      }
    }
  }, [liveAdhocAdData])

  useEffect(() => {
    console.error(liveAdhocAdError)
  }, [liveAdhocAdError])

  useInterval(
    async () => {
      if (isAdhocAdBreakAllowed) {
        await liveAdhocAdCall()
      }
    },
    isAdhocAdBreakAllowed ? 1000 : null,
  )

  useEffect(() => {
    if (!isEmpty(nonLinearAds)) {
      for (let i = 0; i < nonLinearAds.length; i++) {
        const item = nonLinearAds[i]
        handleAdEventCall(item, 'IMPRESSION')
        handleAdEventCall(item, 'VIEW')
      }
    }
  }, [nonLinearAds])

  React.useEffect(() => {
    videojs.registerPlugin('qualityLevels', qualityLevels)
    videojs.registerPlugin('hlsQualitySelector', hlsQualitySelector)
    videojs.registerPlugin('ads', ads)

    let linearAds = adSetData.filter((info) => info.ad_type === 'linear')

    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current
      if (!videoElement) return
      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player)
        handlePlayerReady(player)
        setShowControlBar(true)
        checkTipJarButton()
      }))

      // Initialize ads plugin for both live and non-live content
      // if (!isEmpty(linearAds)) {
      player.ads()
      // }

      player.on('contentchange', () => {
        player.trigger('adsready')
      })

      // Only process linear ads for non-live content
      // if (!isLive && !isVODLive) {
      //   player.controls(false)
      for (let i = 0; i < linearAds.length; i++) {
        const adInfo = linearAds[i]

        if (isEmpty(adInfo?.source_asset_id)) {
          continue
        }

        if (adInfo.ad_location_type === 'pre') {
          playPreRoll(adInfo, playerRef, setShowSettingMenu)
        }
        if (adInfo.ad_location_type === 'post') {
          playPostRoll(adInfo, playerRef, setShowSettingMenu)
        }
        if (adInfo.ad_location_type === 'mid') {
          playMidRoll(adInfo, playerRef, setShowSettingMenu)
        }
        if (adInfo.ad_location_type === 'custom') {
          playCustomRoll(adInfo, playerRef, setShowSettingMenu)
        }
        // }
      }

      player.trigger('adsready')
    } else {
      // you can update player here [update player through props]
      // const player = playerRef.current;
      // player.autoplay(options.autoplay);
      // player.src(options.sources);
    }
  }, [options, videoRef, adSetData])

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  const checkTipJarButton = () => {
    if (!isEmpty(contentInfo.custom_metadata_new)) {
      let buttons = [...contentInfo.custom_metadata_new].filter((info) => {
        let placement = info?.value?.button_data?.button_config?.placement
        return info?.type === 'button' && (placement === 'PLAYER' || placement === 'BOTH')
      })

      if (!isEmpty(buttons)) {
        setTipJarButtons(buttons.map((info) => info.value))
      }
    }
  }

  const handleAdRedirect = (link) => {
    handleRedirect(link)

    captureGAEvent('advertisement', 'advertisement', 'Advertisement', {
      user_id: userObj?._id || '',
      user_email: userObj?.email_id || '',
      ad_name: currentPlayingAd.name,
      campaign_id: currentPlayingAd.ad_campaign,
      content_name: contentInfo.title,
      content_id: contentInfo.content_id,
    })
    handleAdEventCall(currentPlayingAd, 'ENGAGEMENT')
  }

  const handlePlayerReady = (player) => {
    playerRef.current = player

    player.on('waiting', () => {
      console.log('player is waiting')
    })

    player.on('ready', () => {
      player.playsinline(true)
      player.volume(localStorage.getItem('volume') ? localStorage.getItem('volume') : 1)
    })

    player.on('playing', async () => {
      if (isMobile) {
        player.requestFullscreen()
      }

      if (document.pictureInPictureElement) {
        player.requestPictureInPicture()
      }
      localStorage.setItem('volume', player.volume())
      setDuration(Math.floor(player.duration()))
      setPlayerStarted(true)
      setIsPlaying(true)
    })

    player.on('play', async () => {
      setPlayerStarted(true)
      setIsPlaying(true)
    })

    player.on('pause', async () => {
      setIsPlaying(false)
    })

    player.on('timeupdate', function () {
      setCurrentTime(Math.floor(player.currentTime()))
    })

    player.on('fullscreenchange', () => {
      if (player.isFullscreen()) {
        setIsFullScreen(true)
        return
      }
      setIsFullScreen(false)
    })

    player.on('progress', function () {
      const buffPercentage = player.bufferedPercent()
      // console.log('Buffer Percentage: ', buffPercentage * 100)
      setBufferPercent(buffPercentage * 100)
    })

    player.on('enterpictureinpicture', () => {
      setIsPIPMode(true)
    })

    player.on('leavepictureinpicture', () => {
      setIsPIPMode(false)
    })

    player.on('volumechange', () => {
      setVolume(player.volume() * 100)
      localStorage.setItem('volume', player.volume())
    })

    player.on('seeked', async () => {})

    player.on('dispose', async () => {})

    player.on('ended', async () => {})

    player.on('error', () => {})
  }

  useInterval(
    async () => {
      if (stillWatchingActivated) {
        setLastMouseMovedSec((prev) => prev + 1)
      }
    },
    stillWatchingActivated ? 1000 : null,
  )

  useInterval(
    async () => {
      setOpenAreYouStillWatching(true)
      togglePlayPause(!isPlaying)
    },
    stillWatchingAllowed &&
      stillWatchingActivated &&
      isPlaying &&
      lastMouseMovedSec >= parseInt(stillWatchingTime) * 60
      ? 1000
      : null,
  )

  const handleSeek = (event) => {
    let player = playerRef.current
    if (!player) {
      return
    }
    let sec = (event.nativeEvent.offsetX / event.target.parentNode.clientWidth) * player.duration()

    player.currentTime(sec)
  }

  const handleSeekOver = (event) => {
    let player = playerRef.current
    if (!player) {
      return
    }
    setSeekBarHoverPercent(event.nativeEvent.offsetX / event.target.parentNode.clientWidth)
  }

  const activatePipMode = () => {
    let player = playerRef.current
    if (!player) {
      return
    }
    player.requestPictureInPicture()
  }

  const togglePlayPause = (isPlay) => {
    let player = playerRef.current

    if (!player || !isEmpty(currentPlayingAd)) {
      return
    }
    isPlay ? player.play() : player.pause()
  }

  const toggleFullScreen = (isFull) => {
    let player = playerRef.current
    if (!player) {
      return
    }
    isFull ? player.requestFullscreen() : player.exitFullscreen()
  }

  const togglePIPMode = (isPIP) => {
    let player = playerRef.current
    if (!player) {
      return
    }
    isPIP ? player.requestPictureInPicture() : player.exitPictureInPicture()
  }

  const toggleVolume = (value) => {
    let player = playerRef.current
    if (!player) {
      return
    }
    setIsMute(false)
    player.muted(false)
    player.volume(value / 100)
  }

  const toggleMuted = (status) => {
    let player = playerRef.current
    if (!player) {
      return
    }
    player.volume(status ? 0 : 100)
    player.muted(status)
    setIsMute(status)
  }

  const getVolumeIcon = () => {
    if (volume > 49 && volume <= 100) {
      return VolFullIcon
    } else if (volume > 10 && volume <= 49) {
      return VolLowIcon
    } else {
      return VolZeroIcon
    }
  }

  const handleKeyPress = (e) => {
    let player = playerRef.current
    if (!player) {
      return
    }
    if (e.keyCode === 39) {
      player.currentTime(player.currentTime() + 10)
    }
    if (e.keyCode === 37) {
      player.currentTime(player.currentTime() - 10)
    }

    if (e.keyCode === 38) {
      player.volume(player.volume() < 1 ? player.volume() + 0.1 : 1)
    }
    if (e.keyCode === 40) {
      player.volume(player.volume() > 0 ? player.volume() - 0.1 : 0)
    }
  }

  useInterval(
    async () => {
      if (isPlaying && !showSettingMenu && !cursorOverControlBar) {
        setShowControlBar(false)
      }
    },
    showControlBar && !isMobile ? 4000 : null,
  )

  const nonLinearClass = {
    TOP_LEFT: ' top-0 left-0 m-4',
    TOP_CENTER: ' top-0 left-1/2 -translate-x-1/2 mt-4',
    TOP_RIGHT: ' top-0 right-0 m-4',
    BOTTOM_LEFT: `${
      !playerData?.control_bar_always_visible && !showControlBar
        ? 'bottom-0'
        : 'bottom-[70px] md:bottom-[80px]'
    } left-0 mb-4 ml-4`,
    BOTTOM_CENTER: `${
      !playerData?.control_bar_always_visible && !showControlBar
        ? 'bottom-0'
        : 'bottom-[70px] md:bottom-[80px]'
    } left-1/2 -translate-x-1/2 mb-4`,
    BOTTOM_RIGHT: `${
      !playerData?.control_bar_always_visible && !showControlBar
        ? 'bottom-0'
        : 'bottom-[70px] md:bottom-[80px]'
    } right-0 mb-4 mr-4`,
  }

  const handleNonLinearAdClose = async (index) => {
    if (isEmpty(nonLinearAds)) return
    let temp = [...nonLinearAds]
    handleAdEventCall(nonLinearAds[index], 'ENGAGEMENT')

    temp.splice(index, 1)
    setNonLinearAds(temp)
  }

  return (
    <div
      data-vjs-player=""
      className="relative"
      onKeyDown={handleKeyPress}
      tabIndex={-1}
      onMouseMove={() => setShowControlBar(true)}
    >
      <div
        style={{
          zIndex: !isEmpty(currentPlayingAdhocAd) ? 60 : -1,

          opacity: !isEmpty(currentPlayingAdhocAd) ? 1 : 0,
          transition: 'opacity 0.5s ease-in-out',
        }}
        className="w-full h-full absolute "
      >
        {!isEmpty(currentPlayingAdhocAd) && (
          <AdhocAdPlayer
            isMuted={isMuted}
            volumeLevel={volumeLevel}
            adInfo={currentPlayingAdhocAd}
          />
        )}
      </div>

      <div
        style={{
          //   border: '1px solid red',
          height: 'calc(100%)',
          display: !isEmpty(currentPlayingAd) ? 'flex' : 'none',
        }}
        className="w-full relative flex-col py-4 pl-4 pr-7 z-30"
      >
        {currentPlayingAd?.button?.is_enabled &&
          !currentPlayingAd?.button?.position.includes('BOTTOM') && (
            <div
              className={`w-full h-full flex ${positionConfig[currentPlayingAd?.button?.position]}`}
            >
              <button
                style={{
                  fontSize: '12px',
                  backgroundColor: getStyleValue('button_background', 'color', '#ffd91d'),
                  color: getStyleValue('button_text', 'color', '#000'),
                  fontFamily: getStyleValue('button_text', 'font', ''),
                  textAlign: getStyleValue('button_text', 'alignment', ''),
                  height: '34px',
                }}
                className={`border rounded-full px-4 ${getStyleValue(
                  'button_text',
                  'font_format',
                  '',
                )}`}
                onClick={() => handleAdRedirect(currentPlayingAd?.button?.link)}
              >
                {currentPlayingAd?.button?.text}
              </button>
            </div>
          )}
        <div
          style={{ marginTop: 'auto', fontSize: '12px' }}
          className="flex justify-between items-center relative"
        >
          {currentPlayingAd?.button?.is_enabled &&
            currentPlayingAd?.button?.position.includes('BOTTOM') && (
              <button
                style={{
                  fontSize: '12px',
                  background: '#ffd91d',
                  height: '34px',
                  zIndex: 20,
                  //   width: 'fit-content',
                  color: '#000',
                  ...positionConfig[currentPlayingAd?.button?.position],
                }}
                className={`border rounded-full px-4 absolute w-auto ${
                  currentPlayingAd?.button?.position === 'BOTTOM_RIGHT'
                    ? currentPlayingAd?.is_skip_allowed &&
                      currentPlayingAd.ad_location_type !== 'adhoc'
                      ? 'right-[100px]'
                      : 'right-0'
                    : ''
                }`}
                onClick={() => handleAdRedirect(currentPlayingAd?.button?.link)}
              >
                {currentPlayingAd?.button?.text}
              </button>
            )}
          <div className="flex items-center">
            <p className="">{`Ad `}</p>
            <div
              style={{
                width: '3px',
                height: '3px',
                background: '#fff',
                borderRadius: '12px',
                marginLeft: '3px',
                marginRight: '3px',
              }}
            />
            <p>{AdSecondsConvert(adDuration)}</p>
          </div>

          {currentPlayingAd.ad_location_type !== 'adhoc' && currentPlayingAd?.is_skip_allowed && (
            <>
              {skipSeconds > 0 ? (
                <div
                  style={{
                    background: '#00000080',
                    borderRadius: '17px',
                    fontSize: '10px',
                    height: '34px',
                  }}
                  className="px-4 flex justify-center items-center cursor-pointer"
                >
                  <p className="px-1 mr-1" style={{ borderRight: '0.5px solid #e3e3e3' }}>
                    {t('skip_after')}
                  </p>
                  <p>{skipSeconds}</p>
                </div>
              ) : (
                <div
                  style={{
                    background: '#fff',
                    borderRadius: '17px',
                    fontSize: '10px',
                    height: '34px',
                  }}
                  className="px-4 flex text-center justify-center items-center text-black cursor-pointer"
                  onClick={handleSkip}
                >
                  <p className="px-1 mr-1">{t('skip_ad')}</p>
                  <img
                    src={SkipIcon}
                    alt="SkipIcon"
                    style={{
                      width: '9.8px',
                      height: '13px',
                    }}
                  />
                </div>
              )}
            </>
          )}
        </div>

        {/* </div> */}
      </div>

      {!isLive && (
        <div
          style={{ height: 'calc(100% - 54px)' }}
          className="text-white w-full absolute top-0 z-20 flex justify-center items-center"
          onClick={controlBar ? () => togglePlayPause(!isPlaying) : null}
        >
          {!isPlaying ? (
            <img
              src={CentredPlayIcon}
              alt="CentredPlayIcon"
              style={{ marginTop: '54px' }}
              className="z-20 cursor-pointer xl:h-[100px] xl:w-[100px]"
            />
          ) : null}
        </div>
      )}

      {isAudio && isEmpty(currentPlayingAd) && duration && (
        <CustomImage
          imageUrl={getImage(accountObj?.cf_domain_name, contentInfo?.thumbnail)}
          imgClass="w-full h-full "
          loaderClass={'h-full'}
          imgAlt={'thumbnail'}
        />
      )}

      <video ref={videoRef} className={'video-js vjs-theme-fantasy'} />
      {!isEmpty(playerData) && isEmpty(currentPlayingAd) && controlBar && duration && (
        <HeaderBar
          playerData={playerData}
          contentInfo={contentInfo}
          showDisplayIcons={showControlBar}
        />
      )}
      <div
        style={{
          height: `${!showControlBar ? 'calc(100% - 56.5px)' : 'calc(100% - 102.5px)'}`,
          marginTop: !showControlBar ? '0px' : '46px',
          transition: `all 0.25s ease-in`,
        }}
        className="text-white w-full absolute top-0 z-20 flex justify-center items-center"
        onClick={() => togglePlayPause(!isPlaying)}
      >
        {!isEmpty(playerData) ? (
          <>
            <PlayerLogo playerData={playerData} isPlaying={isPlaying} />
            <PlayerWatermark playerData={playerData} isPlaying={isPlaying} />
          </>
        ) : null}
      </div>
      {!isEmpty(tipJarButtons) && isEmpty(currentPlayingAd) && duration && (
        <TipButtonsBar
          tipJarButtons={tipJarButtons}
          activatePipMode={activatePipMode}
          bottomClass={!showControlBar ? 'bottom-0' : 'bottom-[70px] md:bottom-[80px]'}
        />
      )}

      {currentTime !== null && isEmpty(currentPlayingAd) && !isEmpty(nonLinearAds)
        ? nonLinearAds.map((item, index) => {
            return (
              <div
                style={{
                  width:
                    item.non_linear_data.type === 'WIDE' ? 'max(75%, 808px)' : 'max(45%, 480px)',
                  aspectRatio: item.non_linear_data.type === 'WIDE' ? '808 / 100' : '480 / 70',
                }}
                className={`absolute z-50 flex items-center ${
                  nonLinearClass[item.non_linear_data.position]
                }`}
                key={index}
                onClick={
                  item.button?.is_enabled ? null : () => handleAdRedirect(item?.button?.link)
                }
              >
                <CustomImage
                  imageUrl={getImage(accountObj?.cf_domain_name, item.image_s3_key)}
                  imgClass="w-full h-full"
                  loaderClass={'w-full h-full'}
                  imgAlt={`item.name`}
                />

                {item.button?.is_enabled && (
                  <div
                    className={`absolute  z-10 w-full h-full flex 
                      ${positionConfig[item?.button?.position]}
                      `}
                  >
                    <button
                      style={{
                        fontSize: '12px',
                        backgroundColor: getStyleValue(
                          'button_background',
                          'color',
                          '#ffd91d',
                          item,
                        ),
                        color: getStyleValue('button_text', 'color', '#000', item),
                        fontFamily: getStyleValue('button_text', 'font', '', item),
                        textAlign: getStyleValue('button_text', 'alignment', '', item),
                        height: '30px',
                        borderRadius: '6px',
                      }}
                      className={`px-4 ${getStyleValue(
                        'button_text',
                        'font_format',
                        'font-bold',
                        item,
                      )} mx-4`}
                      onClick={() => handleAdRedirect(item?.button?.link)}
                    >
                      {item.button?.text}
                    </button>
                  </div>
                )}
                <img
                  src={NonLinearCloseIcon}
                  alt="NonLinearCloseIcon"
                  style={{
                    margin: '5px',
                  }}
                  className="absolute top-0 right-0 cursor-pointer z-20"
                  onClick={() => {
                    handleNonLinearAdClose(index)
                  }}
                />
              </div>
            )
          })
        : null}

      {/*   <TipJarButton tipJarButtonInfo={tipJarButtonInfo} />
       */}
      {isEmpty(currentPlayingAd) && controlBar && duration && (
        <div
          style={{
            height: isMobile || showControlBar ? '54px' : '0px',
            backgroundColor: '#00000080',
            transition: 'height 0.25s ease-in',
          }}
          className="text-white w-full absolute bottom-0 px-2 "
          onMouseOver={() => setCursorOverControlBar(true)}
          onMouseLeave={() => setCursorOverControlBar(false)}
        >
          <div className="parent-div relative w-full">
            <div
              className={`w-full ${!isVODLive && 'cursor-pointer'}  relative`}
              style={{ background: '#6a738380', height: '5px' }}
              onClick={isVODLive ? null : (e) => handleSeek(e)}
              onMouseOver={isVODLive ? null : (e) => handleSeekOver(e)}
              title={
                isVODLive
                  ? null
                  : `${convertVideoSecondstoMintues(Math.floor(seekBarHoverPercent * duration))}`
              }
            >
              {/* <div
                className="absolute font-semibold border"
                style={{
                  background: '#00000080',
                  zIndex: 20,
                  top: '-25px',
                  padding: '6px',
                  left: `calc(${seekBarHoverPercent}% - 3%)`,
                }}
              >
                {convertVideoSecondstoMintues(seekBarHoverPercent * duration)}
              </div> */}
              <div
                className=" absolute h-full left-0 top-0"
                style={{
                  width: isVODLive ? '100%' : `${(currentTime / duration) * 100}%`,
                  background: 'red',
                  zIndex: 20,
                  transition: 'all 300ms ease',
                }}
              />
              <div
                className="absolute h-full left-0 top-0"
                style={{
                  width: `${bufferPercent}%`,
                  background: '#92888680',
                  zIndex: 5,
                }}
              />
            </div>
          </div>
          <div className="w-full flex justify-between mt-2 relative">
            <div className="flex justify-center items-center ">
              <img
                src={isPlaying ? PauseIcon : PlayIcon}
                alt={isPlaying ? 'PauseIcon' : 'PlayIcon'}
                className="w-8 h-8 cursor-pointer"
                title="Pause"
                onClick={() => togglePlayPause(!isPlaying)}
              />
              {handleNext && handlePrev ? (
                <img
                  src={NextIcon}
                  alt={'NextIcon'}
                  className="w-8 h-8 cursor-pointer ml-2 rotate-180"
                  title="Previous"
                  onClick={() => {
                    handlePrev()
                  }}
                />
              ) : null}
              {handleNext ? (
                <img
                  src={NextIcon}
                  alt={'NextIcon'}
                  className="w-8 h-8 cursor-pointer mx-2"
                  title="Next"
                  onClick={() => {
                    handleNext()
                  }}
                />
              ) : null}

              <div
                className="flex items-center mx-2"
                onMouseEnter={() => setShowVolume(true)}
                onMouseLeave={() => setShowVolume(false)}
              >
                <img
                  src={isMute ? VolMuteIcon : getVolumeIcon()}
                  alt={isMute ? 'VolMuteIcon' : 'VolumeIcon'}
                  className="w-6 h-6 cursor-pointer"
                  title="Volume"
                  onClick={() => toggleMuted(!isMute)}
                />

                {showVolume && (
                  <input
                    type="range"
                    className={`volume-range `}
                    min={0}
                    max={100}
                    step={2}
                    value={volume}
                    onChange={(event) => {
                      toggleVolume(event.target.valueAsNumber)
                    }}
                    style={{
                      width: `${showVolume ? '70px' : '0px'}`,
                      opacity: `${showVolume ? '0.9' : '0'}`,
                    }}
                  />
                )}
              </div>
              {isVODLive ? (
                <div className="mx-2 text-white flex items-center justify-center">
                  <span className="mt-0.5">LIVE</span>
                  <img
                    src={RedCircle}
                    style={{ width: '10px', height: '10px' }}
                    className="ml-1"
                    alt={'live'}
                  />
                </div>
              ) : (
                <p className="italic mx-2">
                  {`${convertVideoSecondstoMintues(currentTime)} / ${convertVideoSecondstoMintues(
                    duration,
                  )}`}
                </p>
              )}
            </div>
            <div className="flex justify-center items-center lg:relative">
              <div className="lg:mx-2">
                <img
                  src={SettingsIcon}
                  alt="PlayIcon"
                  className=" cursor-pointer"
                  title="Setting"
                  style={{ width: '30px', height: '30px' }}
                  onClick={() => setShowSettingMenu(!showSettingMenu)}
                />
              </div>
              {showSettingMenu && (
                <SettingsMenu playerRef={playerRef} setShowSettingMenu={setShowSettingMenu} />
              )}

              <div className="mx-2 hidden lg:block">
                <img
                  src={isPIPMode ? CaptureIcon : PIPIcon}
                  alt={isPIPMode ? 'CaptureIcon' : 'PIPIcon'}
                  className="w-8 h-8 cursor-pointer"
                  title={isPIPMode ? 'CaptureIcon' : 'PIPIcon'}
                  onClick={() => togglePIPMode(!isPIPMode)}
                />
              </div>
              <div className="mx-2">
                <img
                  src={isFullScreen ? FullscreenExitIcon : FullscreenEnterIcon}
                  alt={isFullScreen ? 'FullscreenExitIcon' : 'FullscreenEnterIcon'}
                  className="w-8 h-8 cursor-pointer"
                  title={isFullScreen ? 'FullscreenExitIcon' : 'FullscreenEnterIcon'}
                  onClick={() => toggleFullScreen(!isFullScreen)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CustomVideoJs
